import CommonService from '@/_core/service/commonService';

const udfMixin = {
  data() {
    return {};
  },
  methods: {
    async fetchSchema({ mode, tenantID, navMapFilename }) {
      let fetchedSchema = {};

      if (mode === 'production') {
        const customFileName =
          this.dataType === 'object'
            ? `${tenantID.toLowerCase()}-${this.currentSubRoute}-${
                this.actionType || this.currentActionRoute
              }`
            : `${tenantID.toLowerCase()}-${navMapFilename.toLowerCase()}`;
        const udfFormSchema = await CommonService.getFormSchemaFromLocal(
          customFileName,
          this.currentRoute,
        );
        // eslint-disable-next-line no-unneeded-ternary
        const isUDFForm = udfFormSchema && udfFormSchema.data && udfFormSchema.data.applicationCode ? true : false;

        fetchedSchema = isUDFForm
          ? udfFormSchema
          : this.dataType === 'object'
            ? await CommonService.getFormSchemaFromLocal(
              `${this.currentSubRoute}-${this.actionType || this.currentActionRoute}`,
              this.currentRoute,
            )
            : await CommonService.getFormSchemaFromLocal(
              navMapFilename.toLowerCase(),
              this.currentRoute,
            );
      } else {
        fetchedSchema =
          this.dataType === 'object'
            ? await CommonService.getFormSchemaFromLocal(
                `${this.currentSubRoute}-${this.actionType || this.currentActionRoute}`,
                this.currentRoute,
            )
            : await CommonService.getFormSchemaFromLocal(navMapFilename.toLowerCase());
      }
      return fetchedSchema;
    },
    getConstructedOnSubmitUDFPayload({ mode, webhookAction, apiPayload, payload }) {
      if (mode === 'production') {
        const isUDFEnabled = this.dataObj?.data?.udfEnabled;
        const isWizard = this.dataObj?.data?.type === 'WIZARD';
        const components = isWizard ? this.dataObj?.data?.wizardSteps : this.dataObj?.data?.components;

        if (
          isUDFEnabled &&
          (webhookAction?.requestMethod === 'POST' || webhookAction?.requestMethod === 'PUT')
        ) {
          if (isWizard) {
            components.forEach((component) => {
              if (component && component.components) {
                component.components.forEach((layoutComp) => {
                  if (layoutComp && layoutComp.components && layoutComp.components.length) {
                    layoutComp.components.forEach((childComp) => {
                      if (childComp && childComp.length) {
                        childComp.forEach((nestedChildComp) => {
                          if (
                            nestedChildComp.type !== 'btn' &&
                            nestedChildComp.type !== 'divider' &&
                            nestedChildComp.type !== 'HTMLcontent' &&
                            !Object.keys(apiPayload).includes(nestedChildComp.key)
                          ) {
                            Object.assign(apiPayload, {
                              ...apiPayload,
                              'custom-fields': {
                                ...apiPayload['custom-fields'],
                                additionalProperties: {
                                  ...apiPayload['custom-fields']?.additionalProperties,
                                  [nestedChildComp.key]: payload.formData[nestedChildComp.key],
                                },
                              },
                            });
                          }
                        });
                      }
                    });
                  } else {
                    if (
                      layoutComp.type !== 'btn' &&
                      layoutComp.type !== 'divider' &&
                      layoutComp.type !== 'HTMLcontent' &&
                      !Object.keys(apiPayload).includes(layoutComp.key)
                    ) {
                      Object.assign(apiPayload, {
                        ...apiPayload,
                        'custom-fields': {
                          ...apiPayload['custom-fields'],
                          additionalProperties: {
                            ...apiPayload['custom-fields']?.additionalProperties,
                            [layoutComp.key]: payload.formData[layoutComp.key],
                          },
                        },
                      });
                    }
                  }
                });
              }
            });
          } else {
            components.forEach((component) => {
              if (component && component.components) {
                component.components.forEach((layoutComp) => {
                  layoutComp.forEach((childComp) => {
                    if (
                      childComp.type !== 'btn' &&
                      childComp.type !== 'divider' &&
                      childComp.type !== 'HTMLcontent' &&
                      !Object.keys(apiPayload).includes(childComp.key)
                    ) {
                      Object.assign(apiPayload, {
                        ...apiPayload,
                        'custom-fields': {
                          ...apiPayload['custom-fields'],
                          additionalProperties: {
                            ...apiPayload['custom-fields']?.additionalProperties,
                            [childComp.key]: payload.formData[childComp.key],
                          },
                        },
                      });
                    }
                  });
                });
              } else if (
                component &&
                component.type !== 'btn' &&
                component.type !== 'divider' &&
                component.type !== 'HTMLcontent' &&
                component.key &&
                !Object.keys(apiPayload).includes(component.key)
              ) {
                Object.assign(apiPayload, {
                  ...apiPayload,
                  'custom-fields': {
                    ...apiPayload['custom-fields'],
                    additionalProperties: {
                      ...apiPayload['custom-fields']?.additionalProperties,
                      [component.key]: payload.formData[component.key],
                    },
                  },
                });
              }
            });
          }
        }
      }
      return apiPayload;
    },
  },
};

export default udfMixin;
